import { render, staticRenderFns } from "./CustomAttachment.vue?vue&type=template&id=18a26313&scoped=true&"
import script from "./CustomAttachment.vue?vue&type=script&lang=js&"
export * from "./CustomAttachment.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttachment.vue?vue&type=style&index=0&id=18a26313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a26313",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
